import React from 'react';

const Store = () => {
  const storeLocations = [
    { 
      country: "México",
      position: "top-[42%] left-[35%]",
      url: "https://fnc-international.store/"
    },
    { 
      country: "Colombia",
      position: "top-[55%] left-[51%]",
      url: "https://fundacionnuevacons.mitiendanube.com/"
    },
    { 
      country: "Argentina",
      position: "bottom-[12%] left-[60%]",
      url: "https://fundacionnuevaconsciencia.mitiendanube.com/"
    },
    { 
      country: "Chile",
      position: "bottom-[18%] left-[53%]",
      url: "https://fundacionnuevaconsciencia3.mitiendanube.com/"
    }
  ];

  const mapContainerStyles = `
    relative
    max-w-3xl
    mx-auto
    my-12
    bg-[#751fab]
    rounded-lg
    shadow-lg
    overflow-hidden
  `;

  return (
    <div className="min-h-screen bg-[#751fab]">
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center">
          <img 
            src="/logofncflor.png"
            alt="Nueva Consciencia Logo"
            className="w-[200px] h-[110px] mx-auto mb-8"
          />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nuestras Tiendas en el Mundo
          </h1>
          <p className="text-xl text-white mb-12 max-w-3xl mx-auto">
            Para acceder a nuestras tiendas, solo haz click en el logo de la fundación que está encima de cada país donde tenemos entrega
          </p>
          {/* Map Container */}
          <div className={mapContainerStyles}>
            {/* Mapa base */}
            <img 
              src="/Latam.png"
              alt="Mapa de América Latina"
              className="w-full"
            />
            
            {/* Marcadores de logo */}
            {storeLocations.map((storeLocation, index) => (
              <button
                key={index}
                className={`absolute ${storeLocation.position} transform -translate-x-1/2 -translate-y-1/2`}
                onClick={() => {
                  window.open(storeLocation.url, '_blank');
                }}
              >
                <img 
                  src="/logofncflor.png"
                  alt={`Tienda en ${storeLocation.country}`}
                  className="w-6 h-4 hover:scale-110 transition-transform"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Store;